import PortalIdParser from 'PortalIdParser';
import { ALL_OPEN, ALL_CLOSED, ASSIGNED_TO_ME, UNASSIGNED, SENT, FILTERED, TRASH, EMAIL, MESSENGER, CHAT, ASSIGNED_TO_BOT, FORMS } from 'find-and-filter-data/views-schema/public';

/**
 * @description This is the default view a user is rendered into on a fresh load
 * of the inbox with no previous history.
 */
export const DEFAULT_VIEW = ALL_OPEN;

/**
 * @description These are the top level views to render. This array lists out
 * which views to render as standard views and in what order.
 */
export const STANDARD_VIEWS = [UNASSIGNED, ASSIGNED_TO_ME, ALL_OPEN, CHAT];
const isPortal53 = () => PortalIdParser.get() === 53;
const COLLAPSED_VIEWS_WITHOUT_BOTS = [EMAIL, MESSENGER, FORMS, ALL_CLOSED, SENT, FILTERED, TRASH];

/**
 * @description These are the collapsed views to render. This array lists out
 * which views to render under the More dropdown.
 */
export const COLLAPSED_VIEWS = isPortal53() ? COLLAPSED_VIEWS_WITHOUT_BOTS : [ASSIGNED_TO_BOT, ...COLLAPSED_VIEWS_WITHOUT_BOTS];